import React from 'react'

const VaddioAVBridgeLectureCaptureDevice = () => {
  return (
    <div>VaddioAVBridgeLectureCaptureDevice</div>
  )
}

export default VaddioAVBridgeLectureCaptureDevice